import { HeaderViewModel, SiteListViewModel } from "../Site/ViewModels/SiteListViewModel";
import MonitoringReportViewModel from "../Site/ViewModels/TravelPlan/MonitoringReportViewModel";
import PrimaryFiltersViewModel from "../TripRate/ViewModels/PrimaryFiltersViewModel";
import RankOrderRowViewModel from "../TripRate/ViewModels/RankOrderRowViewModel";
import SecondaryFiltersViewModel from "../TripRate/ViewModels/SecondaryFilteringViewModel";
import LandUsePageViewModel from "../TripRate/ViewModels/TripRateFilterViewModel";
import { TimePair } from "../Utilities/ViewModels/TimePair";

export class SessionState {
    public path: 'SiteList' | 'TripRate' | null = null;
    public version: number | null = null;

    // SiteList
    public siteListType: string = 'active';
    public siteListMain: string = '01';
    public siteListSub: string = 'A';
    public siteListSort: keyof SiteListViewModel = 'reference';
    public siteListDir: 'asc' | 'desc' = 'asc';
    public siteListPage: number = 0;
    public siteListRows: number = 20;
    public siteListTextSearch: string = '';
    public siteListLandSearch: string = '';
    public siteListHeaders: HeaderViewModel[] = [];
    public siteListTableState = {
        siteList: { page: 0, rows: 20 },
        summaryFiltering: { page: 0, rows: 10 },
    };

    // TripRate
    public tripRateType: string = 'active';
    public tripRateMain: string = '01';
    public tripRateSub: string = 'A';
    public tripRateSearch: string = '';
    public landusePage: LandUsePageViewModel = new LandUsePageViewModel();
    public primaryFilters: PrimaryFiltersViewModel = new PrimaryFiltersViewModel();
    public secondaryFilters: SecondaryFiltersViewModel = new SecondaryFiltersViewModel();

    public residentialUnitTypes: number[] = [0, 1, 2, 3, 4, 5, 6];

    public vehicleType: number = 0;
    public tripRateAvailableTimeRange: string = 'N/A';

    public tripRateParamName: string = '';
    public tripRateParamUnit: string = '';
    public tripRateParamDisabled: boolean = false;

    // Selected surveys/ sites
    public selectedSitesAndSurveys: SurveyViewModel[] = [];
    public lastReasonForRemoval: string = '';

    // RankOrder
    public rankOrderSort: keyof RankOrderRowViewModel = 'totals';
    public rankOrderDir: 'asc' | 'desc' = 'desc';
    public rankOrderPage: number = 0;
    public rankOrderRows: number = 19;
    public rankOrderTimes: TimePair[] = [{ start: 24, end: 26 }];
    public rankOrderPeakHour: boolean = false;

    // MonitoringReport
    public monitoringReport: MonitoringReportViewModel = new MonitoringReportViewModel();

    public atcCount: number = 0;
}

export class SaveSessionViewModel {
    public url: string = '';
    public state: string = '';
    public name: string = '';
    public type: string = '';
}
export class LoadSessionViewModel {
    public url: string = '';
    public state: string = '';
}

export class SurveyViewModel {
    surveyRef: string = '';
    siteRef: string = '';
    surveyActive: boolean = true;
    surveyPendingDeselect?: boolean = false;
    siteActive: boolean = true;
    sitePendingDeselect?: boolean = false;
    reasonForSurveyRemoval: string = '';
    reasonForSiteRemoval: string = '';
    resurveyRef: string = '';
    busiestSurveyId: string = '';
    latestSurveyId: string = '';
    date: string = '';
    manuallyRemoved: boolean = false;
    reference: string = '';
}
